module.exports = __webpack_public_path__ + "static/media/18ECA46.a4cd8887.jpg";